import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type {
  DataPlansResponse,
  DataPurchaseResult,
  DataQuote,
  PurchaseDataPayload,
} from '@/types/data';

class DataService {
  getPlans(params?: { network?: string; planType?: string }) {
    return apiClient.get<ApiResponse<DataPlansResponse>>('/users/data/plans', { params });
  }

  getQuote(planId: number) {
    return apiClient.get<ApiResponse<{ quote: DataQuote }>>('/users/data/quote', {
      params: { planId },
    });
  }

  purchase(payload: PurchaseDataPayload) {
    return apiClient.post<ApiResponse<DataPurchaseResult>>('/users/data/purchase', payload, {
      timeout: 45_000,
    });
  }
}

export const dataService = new DataService();
